var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-query-edit-mode clearfix" },
    [
      _c(
        "label",
        { staticClass: "emphasis", class: { "required-flag": !_vm.isBidder } },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("tender.query.closingTime")) + ":\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("DateTimeSelector", {
        attrs: {
          date: _vm.query.closingDate,
          timeOptions: _vm.closingTimeOptions,
          disabledDates: _vm.disabledDates,
          required: true,
          disabled: _vm.isBidder,
          highlightClass: _vm.highlightClass,
          isClosingTime: true,
        },
        on: {
          updateDate: function (val) {
            return _vm.updateValue("closingDate", val)
          },
        },
      }),
      _vm._v(" "),
      _c("question", {
        attrs: { query: _vm.query },
        on: {
          deleteQuestion: function (index) {
            return _vm.deleteQuestion(index)
          },
          updateQuestion: function (index, fieldName, val) {
            return _vm.updateQuestion(index, fieldName, val)
          },
        },
      }),
      _vm._v(" "),
      !_vm.isBidder
        ? _c(
            "button",
            {
              staticClass: "btn add-question-btn",
              attrs: { type: "btton" },
              on: {
                click: function ($event) {
                  return _vm.addQuestion()
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("action.add")) +
                  " " +
                  _vm._s(_vm.$t("tender.query.question")) +
                  "\n    "
              ),
              _c("i", { staticClass: "icon-plus" }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "query-attachments" }, [
        _vm.isBidder && _vm.engineerFiles.length
          ? _c(
              "div",
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("tender.tenderAttachment"))),
                ]),
                _vm._v(" "),
                _c("attachments", {
                  attrs: {
                    noHighlight: true,
                    editView: false,
                    files: _vm.engineerFiles,
                    zipName: _vm.zipPrefix + "_Attachments.zip",
                  },
                  on: {
                    "update:files": function ($event) {
                      _vm.engineerFiles = $event
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("label", { staticClass: "emphasis" }, [
          _vm._v(
            _vm._s(
              _vm.isBidder
                ? _vm.$t("vendor.attachment.vendor")
                : _vm.$t("attachments")
            ) + ": "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("FileUpload", {
              attrs: {
                attachment: _vm.attachments,
                resourceId: _vm.getResourceId(),
              },
              on: {
                "update:attachment": function ($event) {
                  _vm.attachments = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row action-btns align-right" },
        [
          _vm.withCancelBtn
            ? _c(
                "button",
                { staticClass: "btn btn--darkblue", on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("action.cancel")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--white",
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("action.save")) + " " + _vm._s(_vm.$t("asDraft"))
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isDraft && _vm.isPicView
            ? _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  on: {
                    click: function ($event) {
                      return _vm.issue()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("action.issue")) +
                      " " +
                      _vm._s(_vm.$t("tender.query.name"))
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isBidder
            ? _c(
                "DialogSlot",
                {
                  ref: "query-submit-modal",
                  attrs: {
                    id: _vm.tqSubmitModalId,
                    modalBtn: _vm.$t("action.submit"),
                    showCloseBtn: false,
                    beforeOpenModal: _vm.beforeSubmit,
                  },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c("span", { staticClass: "modal-pure-text" }, [
                      _vm._v(_vm._s(_vm.submitHint)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.continueSubmit,
                            expression: "continueSubmit",
                          },
                        ],
                        staticClass: "btn btn--darkblue",
                        attrs: {
                          type: "button",
                          "data-close": "",
                          "aria-label": "Close reveal",
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--orange",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.next()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.continueSubmit
                              ? _vm.$t("action.yesSubmit")
                              : _vm.$t("action.ok")
                          )
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "DialogSlot",
        {
          ref: "detect-update-modal",
          attrs: { id: _vm.queryUpdatedWarningId, showCloseBtn: false },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("span", { staticClass: "confirm-header" }, [
              _vm._v(_vm._s(_vm.$t("error.updateQuery.410"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "data-close": "" },
                on: {
                  click: function ($event) {
                    return _vm.refreshPage()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("hint.okay")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }